import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class LoadingService {
    public isLoadingSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    setLoading(value: boolean): void {
        this.isLoadingSubject.next(value);
    }
}
